import React, { useState } from 'react';
import axios from 'axios';

const WebhookTestButton = () => {
  const [testing, setTesting] = useState(false);
  const [result, setResult] = useState(null);

  const testWebhook = async () => {
    setTesting(true);
    setResult(null);

    try {
      // Test webhook endpoint with a mock payload
      const testPayload = {
        event_type: 'test',
        data: {
          video_id: 'test_video_' + Date.now(),
          status: 'completed',
          message: 'Test webhook from admin dashboard',
          timestamp: new Date().toISOString()
        }
      };

      const response = await axios.post('/api/heygen/webhook', testPayload);

      if (response.data.success) {
        setResult({
          success: true,
          message: 'Webhook test successful! Check the webhook logs to see the event.',
        });
      } else {
        setResult({
          success: false,
          message: 'Webhook test failed: ' + response.data.message,
        });
      }
    } catch (error) {
      setResult({
        success: false,
        message: 'Webhook test error: ' + (error.response?.data?.message || error.message),
      });
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="webhook-test-button">
      <button 
        onClick={testWebhook}
        disabled={testing}
        className={`test-btn ${testing ? 'testing' : ''}`}
      >
        {testing ? '🔄 Testing...' : '🧪 Test Webhook'}
      </button>

      {result && (
        <div className={`test-result ${result.success ? 'success' : 'error'}`}>
          <div className="result-icon">
            {result.success ? '✅' : '❌'}
          </div>
          <div className="result-message">
            {result.message}
          </div>
        </div>
      )}

      <style jsx>{`
        .webhook-test-button {
          margin: 20px 0;
        }

        .test-btn {
          padding: 12px 24px;
          background: #17a2b8;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .test-btn:hover:not(:disabled) {
          background: #138496;
        }

        .test-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .test-btn.testing {
          background: #ffc107;
          color: #212529;
        }

        .test-result {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-top: 15px;
          padding: 12px;
          border-radius: 6px;
          font-size: 14px;
        }

        .test-result.success {
          background: rgba(40, 167, 69, 0.1);
          border: 1px solid rgba(40, 167, 69, 0.3);
          color: #155724;
        }

        .test-result.error {
          background: rgba(220, 53, 69, 0.1);
          border: 1px solid rgba(220, 53, 69, 0.3);
          color: #721c24;
        }

        .result-icon {
          font-size: 16px;
        }

        .result-message {
          flex: 1;
        }
      `}</style>
    </div>
  );
};

export default WebhookTestButton;